import { LOCALES } from '../../../common/constants';
import { get } from '../../api/api.service';

export const fetchEmploymentContractsApi = (): Promise<any> => {
  return get('/employmentcontractv2/get-contract');
};

export const downloadEmploymentContractApi = async (contractId: number | string, lang: string): Promise<void> => {
  const userData = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
  })();
  const token = userData.token || localStorage.getItem('token') || localStorage.getItem('authToken') || '';
  const baseUrl = (import.meta as any).env.VITE_API_URL || '';

  const response = await fetch(`${baseUrl}/employmentcontractv2/${contractId}/download-pdf?lang=${lang}`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) throw new Error(`Download failed: ${response.status}`);

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = 'employment-contract.pdf';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
};

export interface CreateEmploymentContractPayload {
  employeeSignatureDate: string;
  employeeNameClarification: string;
  employeeSignatureFileName: string;
  employeeSignatureFileContent: string;
  isDigitally: boolean;
}

export interface CreateEmploymentContractResponse {
  statusCode: number;
  message: string;
}

export const createEmploymentContractApi = async (
  payload: CreateEmploymentContractPayload
): Promise<CreateEmploymentContractResponse> => {
  const userData = (() => {
    try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
  })();
  const token = userData.token || localStorage.getItem('token') || localStorage.getItem('authToken') || '';
  const baseUrl = (import.meta as any).env.VITE_API_URL || '';
  const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';

  const response = await fetch(`${baseUrl}/employmentcontractv2/request?lang=${lang}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    let errorMessage = 'Failed to submit employment contract';
    const contentType = response.headers.get('Content-Type') || '';
    if (contentType.includes('application/json')) {
      const errorData = await response.json().catch(() => ({}));
      errorMessage = errorData.message || errorMessage;
    }
    throw new Error(errorMessage);
  }

  // API returns the signed contract as a PDF binary — download it
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = 'employment-contract.pdf';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);

  return { statusCode: response.status, message: 'Employment contract submitted successfully.' };
};
